<div class="col-md-10 mx-auto">

    <nav aria-label="breadcrumb">
        <ol class="breadcrumb small">
            <li class="breadcrumb-item"><a routerLink="/">Inicio</a></li>
            <li class="breadcrumb-item"><a routerLink="/cotizar">Cotizar</a></li>
            <li class="breadcrumb-item active">Compañía Logística</li>
        </ol>
    </nav>

    <div class="row">
        <div class="col-md-5 mx-auto py-3 py-md-5">

            <p class="h3 text-center">Compañía Logística</p>

            <mat-horizontal-stepper labelPosition="bottom" [linear]="linear" #stepper>
                <mat-step [stepControl]="formDatos">
                    <ng-template matStepLabel>Datos</ng-template>
                    <form [formGroup]="formDatos" novalidate class="row">
                        <mat-form-field appearance="outline" class="col-12">
                            <mat-label>Nombre</mat-label>
                            <input matInput formControlName="nombre">
                            <mat-error *ngIf="errorNombre()">{{errorNombre()}}</mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="col-12">
                            <mat-label>Apellidos</mat-label>
                            <input matInput formControlName="apellidos">
                            <mat-error *ngIf="errorApellidos()">{{errorApellidos()}}</mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="col-12">
                            <mat-label>RUC</mat-label>
                            <input matInput formControlName="ruc">
                            <mat-error *ngIf="errorRuc()">{{errorRuc()}}</mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="col-12">
                            <mat-label>Email</mat-label>
                            <input matInput formControlName="email">
                            <mat-error *ngIf="errorEmail()">{{errorEmail()}}</mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="col-12">
                            <mat-label>Celular</mat-label>
                            <input matInput formControlName="celular" placeholder="000000000">
                            <mat-error *ngIf="errorCelular()">{{errorCelular()}}</mat-error>
                        </mat-form-field>
                        <!-- <div class="col-6 pt-3">
                            <mat-checkbox formControlName="whatsApp">whatsApp</mat-checkbox>
                        </div> -->
                        <div class="col-12">
                            <mat-checkbox formControlName="acepta" class="small">
                                He leído y acepto la <button type="button" class="myButtonPrivacidad text-primary" (click)="openModalTerminos()"><u>Política de privacidad.</u></button>
                            </mat-checkbox>
                            <mat-error class="small" *ngIf="errorAcepta()">{{errorAcepta()}}</mat-error>
                        </div>
                        <div class="col-12 text-right mt-3 mt-md-4">
                            <button class="btn btn-primary px-3" matStepperNext>Siguiente</button>
                        </div>
                    </form>
                </mat-step>
                <mat-step [stepControl]="formPlan">
                    <ng-template matStepLabel>Plan</ng-template>
                    <form [formGroup]="formPlan" (ngSubmit)="onSubmit()" novalidate class="row">
                        <div class="col-12">
                            <p class="h5 mb-2 mb-md-3">Selecciona un plan:</p>
                        </div>

                        <div class="col-12 mb-3 mb-md-4">
                            <mat-radio-group class="d-flex flex-column " formControlName="tipoPlan">
                                <mat-radio-button *ngFor="let plan of planes" [value]="plan">{{plan.nombre}}</mat-radio-button>
                            </mat-radio-group>
                            <!-- <mat-error class="small" *ngIf="errorTipoPlan()">{{errorTipoPlan()}}</mat-error> -->
                        </div>

                        <mat-form-field appearance="outline" class="col-12">
                            <mat-label>Tipo de vehículo</mat-label>
                            <mat-select formControlName="tipoVehiculo">
                                <mat-option *ngFor="let vehiculo of vehiculos" [value]="vehiculo">{{vehiculo}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="errorTipoVehiculo()">{{errorTipoVehiculo()}}</mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="col-12">
                            <mat-label>Cantidad</mat-label>
                            <mat-select formControlName="cantidad">
                                <mat-option *ngFor="let cantidad of cantidades" [value]="cantidad">{{cantidad}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="errorCantidad()">{{errorCantidad()}}</mat-error>
                        </mat-form-field>
                        <div class="col-12 d-flex justify-content-between mt-3 mt-md-4">
                            <button class="btn btn-primary px-3" matStepperPrevious>Atrás</button>
                            <button class="btn btn-primary px-3" matStepperNext>
                            <mat-spinner *ngIf="deshabilitado" [diameter]="24" class="float-left mr-2"></mat-spinner>
                            Siguiente
                          </button>
                        </div>
                    </form>
                    <!-- <pre>{{formPlan.value | json}}</pre> -->
                </mat-step>
            </mat-horizontal-stepper>

        </div>
    </div>
</div>